$(document).on('click', '.bn_blog-card__menu-icon', function () {
    let that = $(this),
        container = that.parents('.bn_blog-card__menu');

    $('.bn_blog-card__menu-icon').not(that).parents('.bn_blog-card__menu').removeClass('open');

    container.toggleClass('open')

    $(document).on('click', function (event) {
        if ($(event.target).closest('.bn_blog-card__menu-icon, .bn_blog-card__menu-list').length) return;

        $('.bn_blog-card__menu').removeClass('open');
    });
});
